<div class="header mb-3">
  <div fxLayout="row" fxLayoutAlign="start end" >
    <h5 class="title">{{ pageTitle }}</h5>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-0 ">
        <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
          <li
            class="breadcrumb-item"
            *ngIf="crumb.link; else nonClickable"
            [class.active]="last"
            style="cursor: pointer"
            (click)="navigate(crumb.link)"
          >
            <a [routerLink]="crumb.link" style="color: #fcd609; text-decoration: none;">{{ crumb.label }}</a>
          </li>
          <ng-template #nonClickable>
            <li class="breadcrumb-item" [class.active]="last">
              {{ crumb.label }}
            </li>
          </ng-template>
        </ng-container>
      </ol>
    </nav>
  </div>
</div>